import api from 'services/api'
import { Professional } from './Professional'

export class ProfessionalsRepository {
	async getProfessionals(): Promise<Professional[]> {
		const response = await api.get('/dentists?offset=0&limit=100')
		return response.data.rows.map(Professional.fromJson)
	}
}
